import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Application } from '../interfaces/application.interface';

@Injectable({
	providedIn: 'root',
})
export class ApplicationService {
	url: string = 'application';

	constructor(private http: HttpClient) {}

	public get(): Observable<Application[]> {
		return this.http.get<Application[]>(this.url);
	}

	public getOne(id: number): Observable<Application> {
		return this.http.get<Application>(this.url + '/' + id);
	}

	public edit(id: number, displayName: string, image: any) {
		return this.http.put(this.url + '/editInfo', { id, displayName, image });
	}
}
